var map = {
	"./24.png": 6859,
	"./Cabeza, vista dorsal.png": 3307,
	"./Cabeza, vista lateral derecha.png": 9926,
	"./Cabeza, vista lateral izquierda.png": 5166,
	"./Cabeza, vista ventral.png": 3017,
	"./Cuello, vista dorsal.png": 6234,
	"./Cuello, vista ventral.png": 2927,
	"./Dermograma.png": 8253,
	"./Hipocondrio derecho.png": 8748,
	"./Hipocondrio izquierdo.png": 1480,
	"./Miembro anterior derecho, vista dorsal.png": 9395,
	"./Miembro anterior derecho, vista ventral.png": 4052,
	"./Miembro anterior izquierdo, vista dorsal.png": 766,
	"./Miembro anterior izquierdo, vista ventral.png": 5092,
	"./Miembro posterior derecho, vista dorsal.png": 4943,
	"./Miembro posterior derecho, vista ventral.png": 8693,
	"./Miembro posterior izquierdo, vista dorsal.png": 6840,
	"./Miembro posterior izquierdo, vista ventral.png": 8510,
	"./Región inguinal derecha.png": 7105,
	"./Región inguinal izquierda.png": 5664,
	"./Región lateral - Flanco derecho.png": 5610,
	"./Región lateral - Flanco izquierdo.png": 5132,
	"./Región púbica.png": 3331,
	"./Región umbilical.png": 4760,
	"./Región xifoidea.png": 6245
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1193;